module.exports = __webpack_public_path__ + "static/media/video-transparent.6c28eaf8.png";